<template>
  <Modal
    :open="displayModal"
    title="Add Credit"
    size="large"
    modalIcon="fa-regular fa-coins"
    modalIconColor="bg-purple-100 text-purple-700"
    :showEscapeButton="true"
    :showAcceptButton="true"
    :acceptButtonProgress="isProgressing"
    acceptButtonText="Add Credit"
    @close="displayModal = false"
    @onSuccess="addCredit"
    ref="modal"
  >
    <div class="grid grid-cols-2 gap-4">
      <div class="col-span-2">
        <label
          for="user_network"
          class="block text-sm font-medium text-gray-700"
          >Network</label
        >
        <label class="dropdown_wrap">
          <select
            class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
            v-model="data.network_id"
          >
            <option
              v-for="network in networks"
              :value="network.id"
              v-bind:key="network.id"
              >{{ network.name }}</option
            >
          </select>
        </label>
      </div>
      <div class="col-span-2 md:col-span-1">
        <label
          for="user_percentage"
          class="block text-sm font-medium text-gray-700"
          >Expires on <small>(23:59 on the date listed)</small></label
        >
        <input
          type="date"
          name="user_percentage"
          id="user_percentage"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.expires_at"
        />
      </div>
      <div class="col-span-2 md:col-span-1">
        <label
          for="user_percentage"
          class="block text-sm font-medium text-gray-700"
          >Invoice Reference</label
        >
        <input
          type="number"
          name="user_percentage"
          id="user_percentage"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.invoice_number"
        />
      </div>
      <div class="col-span-2 md:col-span-1">
        <label
          for="user_percentage"
          class="block text-sm font-medium text-gray-700"
          >Number of Credits</label
        >
        <input
          type="number"
          name="user_percentage"
          id="user_percentage"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.credits"
        />
      </div>
      <div class="col-span-2 md:col-span-1">
        <label
          for="user_percentage"
          class="block text-sm font-medium text-gray-700"
          >Total Price</label
        >
        <input
          type="number"
          name="user_percentage"
          id="user_percentage"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.price"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import * as Config from "@/config";
import { mapActions } from "vuex";

import Modal from "@/components/Modal";

export default {
  data() {
    return {
      displayModal: false,
      data: {
        network_id: null,
        expires_at: null,
        invoice_number: null,
        credits: null,
        price: null
      },
      isProgressing: false,
      networks: []
    };
  },

  components: {
    Modal
  },

  mounted() {
    this.$nextTick(
      function() {
        this.$eventBus.$on("admin-network-add-credit-open-modal", this.open);
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("admin-network-add-credit-open-modal", this.open);
  },

  methods: {
    ...mapActions(["addToastMessage"]),
    open() {
      this.displayModal = true;
      this.getNetworks();
    },

    async addCredit() {
      let response = await this.$http.post(
        Config.apiPath + "/api/v2/admin/credits/agreements",
        this.data
      );
      if (response.status == 200) {
        this.$eventBus.$emit("admin-network-add-credit-refresh-data");
        this.addToastMessage({
          title: "Success",
          text: "The credit agreement was successfully applied.",
          type: "success"
        });
        this.displayModal = false;
      } else {
        this.addToastMessage({
          title: "Whoops!",
          text: "The credit agreement was not applied due to an error.",
          type: "error"
        });
      }
    },

    async getNetworks() {
      let response = await this.$http.get(
        Config.apiPath + "/api/v2/admin/networks"
      );
      this.networks = response.data;
    }
  }
};
</script>
